import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { FusePageCarded } from '@fuse';
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as Actions from '../../../auth/store/actions';
import { Button, Tab, Tabs, Grid, Divider, DialogTitle, DialogContent, DialogActions, Dialog } from '@material-ui/core';
import * as validatorActions from '../../components/validator/store/actions';
import AuthForm from './AuthForm';
import TabPanelButtons from '../../components/TabPanelButtons';
import PageHeader from 'main/components/PageHeader';
import AuthStudentTab from './AuthStudentTab';
import AuthInstructorTab from './AuthInstructorTab';
import AuthActivityTab from './AuthActivityTab'

const styles = theme => ({
    layoutRoot: {},
    layoutToolbar: {
        padding: 0
    },
    tabsRoot: {
        height: 64,
        flex: 1
    },
    tabRoot: {
        height: 64,
        [theme.breakpoints.up('md')]: {
            minWidth: '144px'
        }
    },
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: '80%',
    },
    textFieldSearch: {
        marginLeft: theme.spacing.unit,
        width: '95%',
    },
    button: {
        margin: theme.spacing.unit,
        minWidth: '80%',
        maxWidth: '80%'
    },
});

class Auth extends Component {
    state = {
        current_tab: 0,
        auth_id: 0,
        view_type: '',
        tabValue: 0,
        deactivateDialogActive: false,
        activateDialogActive: false,
        deleteDialogActive: false
    }

    constructor(props) {
        super(props);

        const auth_id = this.props.match.params.auth_id;
        const view_type = this.props.match.params.view_type;
        // console.log(auth_id)
        this.state = {
            ...this.state,
            auth_id: auth_id,
            view_type: view_type,
        }

        let company_id = 0
        if (this.props.companyAuth.active && this.props.match.params.view_type === 'create') {
            company_id = this.props.companyAuth.company_id
        }
        this.props.updateAuthLoaded(false);
        this.props.getAuthData(auth_id, company_id);

        const validationList = [
            // {
            //     field_name: 'Email', functionName: 'checkEmailValid', 
            // },
            {
                field_name: 'Email', functionName: ['checkEmailUnique', 'checkEmailValid'], id: this.state.auth_id, component: 'auth'
            },
            // {
            //     field_name: 'Password', functionName: ['checkFieldLength'], chars: 4,
            // },
            // {
            //     field_name: 'PasswordConfirm', functionName: ['checkFieldLength'], chars: 4,
            // },
            {
                field_name: 'company_ids', functionName: ['checkFieldLength'], chars: 1
            }
        ]

        this.props.startValidator(validationList)
    }

    disableSave = () => {
        const { validator, currentAuth, companyInfo } = this.props;
        const { view_type } = this.state

        const devRole = currentAuth.roles.filter(r => r.role_id === 1);
        if (companyInfo.company_ids.length === 0) {
            if (devRole.length > 0 && currentAuth.roles.length === 1) { }
            else {
                return true
            }
        }


        switch (view_type) {
            case ("edit"): {
                return (
                    validator.map(v => v.error)
                        .includes(true)
                )
            }
            case ('create'): {
                if (currentAuth.Password != currentAuth.PasswordConfirm) {
                    return true
                }
                return !(
                    validator.every(v => v.error === false)
                )
            }
        }
    }

    handleChangeTab = (event, value) => {
        this.setState({
            ...this.state,
            current_tab: value
        })
    }

    handleSubmit = () => {
        const companyAuth = this.props.companyAuth
        const preloadRole = this.props.preloadRole
        let pushstring = '/user/list'
        if (companyAuth.active) {
            pushstring = '/company/edit/' + companyAuth.company_id;
        }
        if (preloadRole.active) {
            pushstring = `/${preloadRole.role.RoleName.toLowerCase()}/list`
        }
        switch (this.state.view_type) {
            case ("create"):
                {
                    this.props.saveAuth(this.props.currentAuth, [], this.props.companyInfo);

                    this.props.history.push(pushstring);
                    break;
                }

            case ("edit"):
                {
                    this.props.saveAuth(this.props.currentAuth, this.props.currentAuth.deleted_roles, this.props.companyInfo);

                    this.props.history.push(pushstring);
                    break;
                }

            default:
                {

                }
        }
    }

    handleDeleteDialogOpen = () => {
        this.setState({ deleteDialogActive: true })
    }

    handleDeactivateDialogOpen = () => {
        this.setState({ deactivateDialogActive: true })
    }

    handleActivateDialogOpen = () => {
        this.setState({ activateDialogActive: true })
    }

    handleDelete = () => {
        const companyAuth = this.props.companyAuth;
        if (companyAuth.active) {
            this.props.deleteAuth(this.props.currentAuth.auth_id)
            return this.props.history.push('/company/edit/' + companyAuth.company_id);
        }
        else {
            this.props.deleteAuth(this.props.currentAuth.auth_id)
            return this.props.history.push('/user/list');
        }

    }

    handleDeactivate = () => {
        switch (this.state.view_type) {
            case ("edit"):
                {
                    this.props.deactivateAuth(this.props.currentAuth.auth_id)
                    this.props.history.push('/user/list');
                    break;
                }

            default:
                {

                }

        }
    }

    handleActivate = () => {
        switch (this.state.view_type) {
            case ("edit"):
                {
                    this.props.activateAuth(this.props.currentAuth)
                    this.props.history.push('/user/list');
                    break;
                }

            default:
                {

                }

        }
    }

    getPageContent = (current_tab, view_type) => {
        const { classes, currentAuth, theme, companyAuth, preloadRole } = this.props;

        switch (current_tab) {
            case (0):
                {
                    return (
                        <AuthForm
                            view_type={view_type}
                            companyAuth={companyAuth}
                            preloadRole={preloadRole}
                        />
                    )
                }
            case (1):
                {
                    return (
                        <AuthInstructorTab
                            currentAuth={this.props.currentAuth}
                            view_type={view_type}
                        />
                    )
                }
            case (2):
                {
                    return (
                        <AuthStudentTab
                            currentAuth={this.props.currentAuth}
                            view_type={view_type}
                        />
                    )
                }
            case (3):
                {
                    return (
                        <AuthActivityTab
                            view_type={view_type}
                            currentAuth={currentAuth}
                        />
                    )
                }
            default:
                {
                    return <React.Fragment>Error: No tab found.</React.Fragment>
                }
        }
    }

    getDeactivateDialog = (active) => {
        return (
            <Dialog
                open={active}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                onBackdropClick={() => this.setState({ deactivateDialogActive: false })}
            >
                <DialogTitle>Confirm Deactivate {this.props.currentAuth.FirstName + ' ' + this.props.currentAuth.LastName}?</DialogTitle>
                <DialogContent>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => this.handleDeactivate()} color="primary">
                        Deactivate
                        </Button>
                    <Button onClick={() => this.setState({ deactivateDialogActive: false })} color="primary" autoFocus>
                        Go Back
                        </Button>
                </DialogActions>
            </Dialog>
        )
    }

    getActivateDialog = (active) => {
        return (
            <Dialog
                open={active}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                onBackdropClick={() => this.setState({ activateDialogActive: false })}
            >
                <DialogTitle>Confirm Activate {this.props.currentAuth.FirstName + ' ' + this.props.currentAuth.LastName}?</DialogTitle>
                <DialogContent>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => this.handleActivate()} color="primary">
                        Activate
                        </Button>
                    <Button onClick={() => this.setState({ activateDialogActive: false })} color="primary" autoFocus>
                        Go Back
                        </Button>
                </DialogActions>
            </Dialog>
        )
    }

    getDeleteDialog = (active) => {
        return (
            <Dialog
                open={active}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                onBackdropClick={() => this.setState({ deleteDialogActive: false })}
            >
                <DialogTitle>Confirm Delete {this.props.currentAuth.FirstName + ' ' + this.props.currentAuth.LastName}?</DialogTitle>
                <DialogContent>
                    <div>This will delete all roles and data associated.</div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => this.handleDelete()} color="primary">
                        Delete
                        </Button>
                    <Button onClick={() => this.setState({ deleteDialogActive: false })} color="primary" autoFocus>
                        Go Back
                        </Button>
                </DialogActions>
            </Dialog>
        )
    }

    render() {
        const { classes, currentAuth, isAuthLoaded } = this.props;
        const { current_tab, view_type } = this.state;
        const deactivate_dialog = this.getDeactivateDialog(this.state.deactivateDialogActive, this.props.currentAuth)
        const delete_dialog = this.getDeleteDialog(this.state.deleteDialogActive, this.props.currentAuth)
        const activate_dialog = this.getActivateDialog(this.state.activateDialogActive, this.props.currentAuth)

        if (!isAuthLoaded) {
            return <div>loading</div>
        }

        let page_content = <React.Fragment>Loading...</React.Fragment>;
        if (isAuthLoaded) {
            page_content = this.getPageContent(current_tab, view_type);
        }

        return (
            <FusePageCarded
                classes={{
                    root: classes.layoutRoot,
                    toolbar: classes.layoutToolbar
                }}
                header={
                    <PageHeader
                        component_name={currentAuth.FirstName + " " + currentAuth.LastName + " (" + currentAuth.Email + ")"}
                        component_type={"user"}
                        view_type={view_type}
                    />
                }
                contentToolbar={
                    <div style={{ width: '100%', height: '100%', }}>
                        <Grid container>
                            <Tabs
                                value={current_tab}
                                onChange={this.handleChangeTab}
                                indicatorColor="primary"
                                textColor="primary"
                                classes={{
                                    root: classes.tabsRoot
                                }}
                                scrollable={true}
                            >
                                <Tab
                                    classes={{
                                        root: classes.tabRoot
                                    }}
                                    label="Detail"
                                />
                                <Tab
                                    classes={{
                                        root: classes.tabRoot
                                    }}
                                    label="Instructor"
                                    hidden={this.props.currentAuth.roles.filter(r => r.RoleName === 'Instructor' && r.from_db === 1).length === 0}
                                />
                                <Tab
                                    classes={{
                                        root: classes.tabRoot
                                    }}
                                    label="Student"
                                    hidden={this.props.currentAuth.roles.filter(r => r.RoleName === 'Student' && r.from_db === 1).length === 0}
                                />
                                <Tab
                                    classes={{
                                        root: classes.tabRoot
                                    }}
                                    label="Activity"
                                />
                            </Tabs>
                            <TabPanelButtons
                                component_name={"user"}
                                view_type={view_type}
                                button_list={[
                                    {
                                        display: "Save",
                                        type: "update",
                                        onClick: this.handleSubmit,
                                        disabled: this.disableSave(),
                                    },
                                    {
                                        type: "delete",
                                        onClick: this.handleDeleteDialogOpen,
                                    },
                                    {
                                        type: "deactivate",
                                        onClick: this.handleDeactivateDialogOpen,
                                        hidden: this.props.currentAuth.DeletedAt,
                                    },
                                    {
                                        type: "activate",
                                        onClick: this.handleActivateDialogOpen,
                                        hidden: !this.props.currentAuth.DeletedAt,
                                    },
                                    {
                                        type: "back",
                                        onClick: this.props.history.goBack
                                    }
                                ]}
                            />
                        </Grid>
                    </div>
                }
                content={
                    <React.Fragment>
                        <div className="p-24">
                            {deactivate_dialog}
                            {activate_dialog}
                            {delete_dialog}
                            {page_content}
                        </div>
                    </React.Fragment>
                }
            />
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getAuth: Actions.getAuth,
        updateAuthLoaded: Actions.updateAuthLoaded,
        getAuthData: Actions.getAuthData,
        saveAuth: Actions.saveAuth,
        deactivateAuth: Actions.deactivateAuth,
        deleteAuth: Actions.deleteAuth,
        activateAuth: Actions.activateAuth,
        startValidator: validatorActions.startValidator
    }, dispatch);
}

function mapStateToProps({ validator, auth, paramHistory }) {
    return {
        currentAuth: auth.crud.currentAuth,
        isAuthLoaded: auth.crud.isAuthLoaded,
        validator: validator.list,
        currentLoggedInUser: auth.user.data.auth_id,
        companyInfo: auth.crud.companyInfo,
        companyAuth: paramHistory.companyAuth,
        preloadRole: paramHistory.authPreloadRole
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(Auth)));


// WEBPACK FOOTER //
// src/main/content/auth/Auth.js